import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Markdown from '../Markdown'
import { bodyText } from '../player/playerStyles'

// An information screen: the sign-off itself is recorded by an assessor in
// the learner's workplace, not in the player.
const PracticalSignoffInfo = ({ block, content }) => {
  const signoff = content?.pathway?.practicalSignoff
  return (
    <Box>
      <Markdown sx={bodyText}>{block.body}</Markdown>
      {signoff?.items?.length > 0 && (
        <>
          <Typography component="h3" sx={{ fontSize: '1.125rem', fontWeight: 700, mt: 2.5, mb: 1 }}>
            {signoff.title}
          </Typography>
          <Markdown sx={bodyText}>{signoff.description}</Markdown>
          <Box component="ul" sx={{ ...bodyText, mt: 1.5, mb: 0, pl: 3 }}>
            {signoff.items.map((item) => (
              <Box component="li" key={item.id} sx={{ mb: 0.75 }}>
                {item.text}
              </Box>
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}

export default PracticalSignoffInfo
